export var PositionsProviderEventType;
(function (PositionsProviderEventType) {
    PositionsProviderEventType["AddPosition"] = "addPosition";
    PositionsProviderEventType["UpdatePosition"] = "updatePosition";
    PositionsProviderEventType["RemovePosition"] = "removePosition";
    PositionsProviderEventType["AddCorporateAction"] = "addCorporateAction";
    PositionsProviderEventType["UpdateCorporateAction"] = "updateCorporateAction";
    PositionsProviderEventType["RemoveCorporateAction"] = "removeCorporateAction";
})(PositionsProviderEventType || (PositionsProviderEventType = {}));
